import Base from './base';
import Header from './header';
import Sidebar from './sidebar';
import Breadcrumbs from './breadcrumbs';
export { Header, Sidebar, Breadcrumbs };
export default Base;
